<template>
  <modal ref="modal">
    <modal-body :message="message" class="text-danger" />
    <modal-footer>
      <base-button class="btn-dark" text="OK" data-coreui-dismiss="modal" />
    </modal-footer>
  </modal>
</template>

<script>
import Modal from "@/views/atoms/Modal";
import ModalBody from "@/views/atoms/ModalBody";
import ModalFooter from "@/views/atoms/ModalFooter";
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: "ShowErrorUploadModal",
  components: {
    Modal,
    ModalBody,
    ModalFooter,
    BaseButton,
  },
  data() {
    return {
      message: '',
    };
  },
  methods: {
    show(message) {
      this.message = message;
      this.$refs.modal.show();
    },
  },
}
</script>
